export default __webpack_public_path__ + "static/media/playlistWatch.67b02535.svg";